import React from "react";

export default function OfficeIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#3E4957"
        d="M11.443 6H5.557L5.5 8H6c.18-1.096.356-1.192 1.694-1.235l.293-.01v5.09c0 .47-.1.582-.898.655v.5H9.91v-.5c-.803-.073-.903-.184-.903-.654V6.755l.298.01C10.644 6.808 10.82 6.905 11 8h.5l-.057-2Z"
      />
      <path
        fill="#3E4957"
        d="M14.5 4.5V14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2H10l4.5 4.5Zm-3 0A1.5 1.5 0 0 1 10 3V1H4.5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2Z"
      />
    </svg>
  );
}
